/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface WhiteLabelState {
  endUserDesiredSpaceID: string | null;
}

const getInitialEndUserDesiredSpaceID = (): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('smorgEndUserDesiredSpaceID');
  }
  return null;
};

export const persistEndUserDesiredSpaceID = (spaceID: string | null) => {
  if (typeof window !== 'undefined') {
    if (spaceID) {
      localStorage.setItem('smorgEndUserDesiredSpaceID', spaceID);
    } else {
      localStorage.removeItem('smorgEndUserDesiredSpaceID');
    }
  }
};

const initialState: WhiteLabelState = {
  endUserDesiredSpaceID: getInitialEndUserDesiredSpaceID(),
};

export const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState,
  reducers: {
    setEndUserDesiredSpaceID: (state, action: PayloadAction<string>) => {
      state.endUserDesiredSpaceID = action.payload;
      persistEndUserDesiredSpaceID(action.payload);
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
  //     state.endUserDesiredSpaceID = null;
  //   });
  // },
});

export const { setEndUserDesiredSpaceID } = whiteLabelSlice.actions;

export default whiteLabelSlice.reducer;
